/**
 * Whether the reader is at `to`, or somewhere beneath it (DX-352).
 *
 * The one rule the bar, the column's rows and its Areas section all mark the
 * current place by. By path segment, so a service three levels into the
 * catalog still marks Catalog, while `/products` does not mark `/product`.
 * `/` is a prefix of every path in the portal, so it — and anything called
 * with `end` — is matched exactly.
 */
export const isActivePath = (pathname: string, to: string, end = false) =>
  end || to === '/'
    ? pathname === to
    : pathname === to || pathname.startsWith(`${to}/`);
